import { ContainerLoadingStatus, ContainerStatusEnum, ModeOfExportEnum } from "@gtpl/shared-models/common-models";
import { SaleOrderDetailViewInfoDTO, SaleOrderDropDownDto, SODto } from '@gtpl/shared-models/sale-management';
import { marksAndNoReq } from "./book-container-dto";
export class ContainerStatusInfo {
    containerNo: string;
  
    containerStatus: ContainerStatusEnum;
    saleOrder: SaleOrderDropDownDto;
    loadingStatus: ContainerLoadingStatus;
    createdUser?: string;
    updatedUser?: string;
    containerId?: number;
    saleOrderId?: number;
    examinationDate?:Date;
    saleOrderNumber?: string;
    referenceNumber?: string;
    scac?: string;
    poNo?: string;
    buyerPoNo?: string;
    customer?: string;
    etd?: Date;
    endCustomer?: string;
    destination?: string;
    grossWeight?: boolean;
    plant?: string;
    plantId?: number;
    filePath?: any[];
    isInvoiced?: string;
    isGrossWeightUpdated?: boolean;
    fgQty?:number;
    poQty?:number;
    stockId?:number;
    brand?:string;
    lineSeal?:string;
    vehicleNumber?:string;
    driverName?:string;
    vesselName?:string;
    shippingBillNo?:string;
    transporter?:string;
    vesselNumber?:string;
    vesselSchedule?:Date;
    qcReport?:string;
    buyerInspectionReport?:string;
    vesselScheduleApproval?:string;
    temperature?:string;
    scrollNo?:string;
    portCode?:string;
    containerSize?: string;
    eta?: Date;
    shippingLiner?:string;
    branchCode?:string;
    shippingBillDate?:Date;
    tempIndicatorNo1?:string;
    tempIndicatorNo2?:string;
    tempIndicatorNo3?:string;
    blNo?:string
    checkListStatus?:number
    shippmentDetailsStatus?:number
    modeOfExport?:ModeOfExportEnum
    marksAndNo?:marksAndNoReq[]
    postShipmentReceivedStatus?:boolean
    invoiceNumber?:any
/**
 * 
 * @param containerNo 
 * @param containerStatus 
 * @param saleOrder 
 * @param loadingStatus 
 * @param createdUser 
 * @param containerId 
 * @param updatedUser 
 * @param saleOrderNumber 
 * @param referenceNumber 
 * @param scac 
 * @param poNo 
 * @param buyerPoNo 
 * @param customer 
 * @param etd 
 * @param endCustomer 
 * @param destination 
 * @param grossWeight 
 * @param plant 
 * @param plantId 
 * @param filePath 
 * @param isInvoiced 
 * @param isGrossWeightUpdated 
 * @param fgQty 
 * @param poQty 
 * @param stockId 
 * @param brand 
 */
    constructor(containerNo: string, containerStatus: ContainerStatusEnum, saleOrder: SaleOrderDropDownDto, loadingStatus: ContainerLoadingStatus, createdUser?: string, containerId?: number, updatedUser?: string, saleOrderNumber?: string, referenceNumber?: string, scac?: string, poNo?: string, buyerPoNo?: string, customer?: string, etd?: Date, endCustomer?: string, destination?: string, grossWeight?: boolean, plant?: string, plantId?: number, filePath?: any[], isInvoiced?: string,brand?:string,lineSeal?:string, vehicleNumber?:string, driverName?:string, vesselName?:string, shippingBillNo?:string, transporter?:string, vesselNumber?:string, vesselSchedule?:Date, qcReport?:string, buyerInspectionReport?:string, vesselScheduleApproval?:string, temperature?:string, scrollNo?:string, portCode?:string, isGrossWeightUpdated?:boolean,fgQty?:number,poQty?:number,stockId?:number,containerSize?: string,eta?:Date,shippingLiner?:string,examinationDate?:Date,branchCode?:string,shippingBillDate?:Date,tempIndicatorNo1?:string,blNo?:string,checkListStatus?:number,shippmentDetailsStatus?:number,modeOfExport?:ModeOfExportEnum,marksAndNo?:marksAndNoReq[],postShipmentReceivedStatus?:boolean,invoiceNumber?:any) {
        this.containerNo = containerNo; 
        this.shippingLiner = shippingLiner;
        this.examinationDate = examinationDate;
        

        this.containerStatus = containerStatus;
        this.saleOrder = saleOrder;
        this.loadingStatus = loadingStatus;
        this.createdUser = createdUser;
        this.containerId = containerId;
        this.updatedUser = updatedUser;
        this.saleOrderNumber = saleOrderNumber;
        this.referenceNumber = referenceNumber;
        this.scac = scac;
        this.poNo = poNo;
        this.buyerPoNo = buyerPoNo;
        this.customer = customer;
        this.etd = etd;
        this.endCustomer = endCustomer;
        this.destination = destination;
        this.grossWeight = grossWeight;
        this.plant = plant;
        this.plantId = plantId;
        this.filePath = filePath;
        this.isInvoiced = isInvoiced;
        this.isGrossWeightUpdated = isGrossWeightUpdated;
        this.fgQty = fgQty;
        this.poQty = poQty;
        this.stockId = stockId;
        this.brand = brand;
        this.lineSeal = lineSeal;
        this.vehicleNumber = vehicleNumber;
        this.driverName = driverName;
        this.vesselName = vesselName;
        this.shippingBillNo = shippingBillNo;
        this.transporter = transporter;
        this.vesselNumber = vesselNumber;
        this.vesselSchedule = vesselSchedule;
        this.qcReport = qcReport;
        this.buyerInspectionReport = buyerInspectionReport;
        this.vesselScheduleApproval = vesselScheduleApproval;
        this.temperature = temperature;
        this.scrollNo = scrollNo;
        this.portCode = portCode;
        this.containerSize = containerSize;
        this.eta= eta;
        this.branchCode = branchCode;
        this.shippingBillDate =shippingBillDate;
        this.tempIndicatorNo1=tempIndicatorNo1;
        this.blNo=blNo
        this.checkListStatus =checkListStatus
        this.shippmentDetailsStatus =shippmentDetailsStatus
        this.modeOfExport = modeOfExport
        this.marksAndNo = marksAndNo
        this.postShipmentReceivedStatus=postShipmentReceivedStatus
        this.invoiceNumber = invoiceNumber
    }

}

